import { redirect } from 'react-router-dom';
import { AppConfigs, UserMetaData } from '../../core/redux/auth/authTypes';
import {
  getUserMetaDataLS,
  getAppConfigsLS,
} from '../../core/utils/auth/authUtils';
import { Dispatch } from '@reduxjs/toolkit';

export const homeValidator = async (isAuthenticated: boolean) => {
  // const user: UserMetaData | null = getUserMetaDataLS();

  if (!isAuthenticated) return redirect('/auth');

  // const appConfigs: AppConfigs | null = getAppConfigsLS();

  // if (!user || !appConfigs) return redirect('/auth');

  return null;
};

export const loginValidator = async () => {
  const user: UserMetaData | null = getUserMetaDataLS();
  if (user) {
    return redirect('/auth');
  }

  return null;
};

export const authValidator = (isAuthenticated: boolean) => {
  if (isAuthenticated) return redirect('/');

  const user: UserMetaData | null = getUserMetaDataLS();
  
  const appConfigs: AppConfigs | null = getAppConfigsLS();

  if (!user || !appConfigs) return redirect('/login');

  return null;
};
